import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppToastHostComponent } from './design/components/app-toast-host/app-toast-host.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AppToastHostComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
}
